export const CATEGORIES = [
  "politics",
  "sports",
  "finance",
  "crypto",
  "history",
  "science",
  "technology",
  "health",
  "culture",
  "environment",
  "law",
  "education",
  "entertainment",
  "military",
  "religion",
];

export const CATEGORY_META = {
  politics: { label: "Politics", color: "#7aa2ff" },
  sports: { label: "Sports", color: "#5ee0c8" },
  finance: { label: "Finance", color: "#e8c47a" },
  crypto: { label: "Crypto", color: "#f0a35e" },
  history: { label: "History", color: "#9b8cff" },
  science: { label: "Science", color: "#6ec8ff" },
  technology: { label: "Technology", color: "#4d9fff" },
  health: { label: "Health", color: "#7dffb3" },
  culture: { label: "Culture", color: "#ff9ecf" },
  environment: { label: "Environment", color: "#6fd98a" },
  law: { label: "Law", color: "#a8b4c8" },
  education: { label: "Education", color: "#8fd3ff" },
  entertainment: { label: "Entertainment", color: "#ffb07a" },
  military: { label: "Military", color: "#6a7aaa" },
  religion: { label: "Religion", color: "#c9b6ff" },
};

export function mixCategoryColor(scores, target, colorMap) {
  let r = 0;
  let g = 0;
  let b = 0;
  let w = 0;
  for (const key of CATEGORIES) {
    const p = scores[key] || 0;
    if (p <= 0) continue;
    const hex = (colorMap && colorMap[key]) || CATEGORY_META[key].color;
    const cr = parseInt(hex.slice(1, 3), 16);
    const cg = parseInt(hex.slice(3, 5), 16);
    const cb = parseInt(hex.slice(5, 7), 16);
    r += cr * p;
    g += cg * p;
    b += cb * p;
    w += p;
  }
  if (w <= 0) {
    target.set(180, 200, 255);
    return target;
  }
  target.set(Math.round(r / w), Math.round(g / w), Math.round(b / w));
  return target;
}

export function primaryCategory(scores) {
  let best = CATEGORIES[0];
  let bestValue = -1;
  for (const key of CATEGORIES) {
    const value = scores[key] || 0;
    if (value > bestValue) {
      best = key;
      bestValue = value;
    }
  }
  return best;
}

export function entropy01(scores) {
  let h = 0;
  for (const key of CATEGORIES) {
    const p = (scores[key] || 0) / 100;
    if (p > 0) h -= p * Math.log(p);
  }
  return Math.min(1, h / Math.log(4));
}
